/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Loading_Translations_Please_WaitInputs */



/**
* | output |
* | --- |
* | "Loading {count} translations... please wait..." |
*
* @param {Loading_Translations_Please_WaitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const loading_translations_please_wait = /** @type {((inputs: Loading_Translations_Please_WaitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_Translations_Please_WaitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Chargement de ${i?.count} traductions... veuillez patienter...`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Übersetzungen werden geladen... Bitte warten...`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Caricamento di ${i?.count} traduzioni... attendere prego...`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Загрузка ${i?.count} переводов... пожалуйста, подождите...`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Cargando ${i?.count} traducciones... por favor espere...`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`正在加载 ${i?.count} 个翻译……请稍候……`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count}件の翻訳を読み込んでいます...お待ちください...`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} अनुवाद लोड हो रहे हैं... कृपया प्रतीक्षा करें...`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`A carregar ${i?.count} traduções... aguarde...`)
	return /** @type {LocalizedString} */ (`Loading ${i?.count} translations... please wait...`)
});